import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService, X_AUTH_SESSION_KEY } from '../services/auth.service';

export const authSessionGuard: CanActivateFn = (): UrlTree | boolean => {
  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);
  const xAuthSession: string | null = localStorage.getItem(X_AUTH_SESSION_KEY);

  if (xAuthSession) {
    return true;
  }

  authService.logout();
  return router.createUrlTree(['/login']);
};
